import { memo, useEffect } from 'react'

import { getPermissionRequiredRoute } from '@surglogs-app/routing'

import { useAuthContext } from '../../hooks'

export const PermissionRequiredErrorScreen = memo(
  ({ error }: { error: unknown }) => {
    const { contextDataStore } = useAuthContext()

    useEffect(() => {
      const userId = contextDataStore.getData()?.user.id

      if (userId) {
        contextDataStore.fetchData()
      }
    }, [contextDataStore])

    useEffect(() => {
      if (window.location.pathname !== getPermissionRequiredRoute()) {
        window.location.href = getPermissionRequiredRoute()
      }
    }, [error])

    return null
  },
)
